import { render } from "./ReviewLearnosityApplication.vue?vue&type=template&id=581d8eda"
import script from "./ReviewLearnosityApplication.vue?vue&type=script&lang=js"
export * from "./ReviewLearnosityApplication.vue?vue&type=script&lang=js"
script.render = render

export default script